import { render, staticRenderFns } from "./drawer-history-log-sidebar.vue?vue&type=template&id=480b392c&"
import script from "./drawer-history-log-sidebar.ts?vue&type=script&lang=ts&"
export * from "./drawer-history-log-sidebar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.1_cache-loader@4.1.0_webpack@4.44.2__css-loader@3.5.2_webpack@4.44.2__lodash@_woylw74pnr2dauffvwh757gxea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports